export default __webpack_public_path__ + "static/media/me222.af40b479.png";